module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 g-bg-main g-py-30 g-px-30 text-center g-rounded-15"
  }, [_c('p', {
    staticClass: "g-color-white"
  }, [_vm._v("Need to order your frame collection?")]), _vm._v(" "), _c('button', {
    staticClass: "btn u-btn-blue g-color-white g-rounded-10 g-px-15",
    on: {
      "click": function($event) {
        return _vm.ScrollBottom()
      }
    }
  }, [_vm._v("Click Here")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-55316983", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55316983"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/frameResources/frameComponents/FrameOrderCollection.vue
// module id = 523
// module chunks = 4